const reconnect_timeout = (min, max) => min + (max - min) * Math.random();
export const err_reconnect_timeout = () => reconnect_timeout(700, 3500);
